import { render, staticRenderFns } from "./ProjPick.vue?vue&type=template&id=5be55f76"
import script from "./ProjPick.vue?vue&type=script&lang=js"
export * from "./ProjPick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports